// extracted by mini-css-extract-plugin
export const news_item = "k_bj";
export const first = "k_bk";
export const inline = "k_bl";
export const news_title = "k_bm";
export const news_descr = "k_bn";
export const news_date = "k_bp";
export const news_footnote = "k_bq";